import { combineReducers } from 'redux';
import {
} from '../constants/toastComponentConstants';

const toastComponentReducer = combineReducers({
});

export default toastComponentReducer;
